export default "__VITE_ASSET__CTodrK20__"